import React from 'react';
import { OrderRefIcon } from '@hero/web-icons';
import { cn } from '@hero/web-lib';

export interface RefDisplayProps {
  refMain?: string;
  refShort?: string;
  icon?: React.ReactNode;
  onClick?: (e: React.MouseEvent) => void;
  className?: string;
}

export const RefDisplay: React.FC<RefDisplayProps> = ({
  refMain,
  refShort,
  icon,
  onClick,
  className,
}) => {
  return (
    <div
      onClick={onClick}
      className={cn(
        'flex items-center gap-1.5 text-sm text-gray-600',
        onClick && 'font-semibold text-blue-600 cursor-pointer hover:underline',
        className,
      )}>
      {icon ?? <OrderRefIcon className="size-3.5 text-gray-400 flex-shrink-0" />}
      <span className="truncate">{refMain || refShort || 'N/A'}</span>
    </div>
  );
};
